export default {
  skip_to_main_content: 'Перейти до основного змісту',
  show_system_messages: 'Показати системні повідомлення',
  dont_show_system_messages: 'Приховати системні повідомлення',
  logged_in: 'Орендаря автентифіковано',
  logged_out: 'Анонімний користувач',
  button_tooltip_switch_locale: 'Змінити мову',
  button_tooltip_activate_voice_recognition: 'Увімкнути розпізнавання голосу',
  date_input: 'Виберіть дату',
  choose_two_dates: 'Будь ласка, оберіть дві дати',
  date_range: 'Діапазон дат',
  from: 'від',
  to: 'до',
  avatar: 'Аватар',
  exit: 'Кінець',
  new: 'Новий',
  back: 'Назад',
  address: 'Адреса',
  suggestions: 'Пропозиції',
  senton: 'Відправлено',
  message_placeholder: 'Введіть повідомлення тут...',
  message_aria: 'Введіть повідомлення тут',
  upload_in_progress: 'Завантаження триває...',
  comment_placeholder: 'Введіть коментар тут',
  message_button_label: 'Відправити',
  please_confirm: 'Будь ласка, підтвердіть',
  no: 'Ні',
  yes: 'Так',
  modal_delete_session: 'Видалити сесію',
  modal_delete_session_notification:
    'Якщо ви закриєте вікно, ваш сеанс також буде видалено.<br>Ви згодні?',
  template_contact_time: "Коли ми можемо з вами зв'язатися?",
  template_pause:
    'Ваш сеанс призупинено. Один з наших співробітників служби підтримки розгляне ваш запит найближчим часом',
  template_continue_after_pause:
    'Ваш сеанс відновлено. Тепер ви можете продовжити писати з нашим чат-ботом',
  choose_date: 'Будь ласка, оберіть дату',
  button_apply: 'Прийняти',
  button_cancel: 'Скасувати',
  none: 'Жодного',
  book_appointment: 'Забронювати зустріч',
  address_input: 'Вхідна адреса',
  data_processing: 'Обробка даних',
  privacy_policy: 'Політика конфіденційності',
  data_processing_notification_before_link:
    'Для того, щоб ви могли користуватися цим чатом, вам необхідно ознайомитися з розділом ',
  data_processing_notification_after_link: 'Приймаю',
  button_accept: 'Прийняти',
  select_date: 'вибрати дату',
  rate_conversation: 'Як би ви оцінили цю розмову',
  new_ticket_question: 'Чи можу я ще чимось допомогти?',
  thank_you:
    'Дякую за вашу підтримку. Ваші відгуки допомагають мені постійно вдосконалюватися',
  goodbye: 'До зустрічі',
  start_new: 'Почніть нову розмову',
  operator_entered_the_chat: 'Оператор увійшов до чату',
  operator_left_the_chat: 'Оператор залишив чат',
  bg_image: process.env.VUE_APP_EN_BG,
  expand_quickreplies: 'Більше',
  collapse_quickreplies: 'Менше',
  login: 'Увійдіть',
  logout: 'Вихід',
  close: 'Закрити',
  messenger_text:
    "Ви можете написати нашому чат-боту або зв'язатися з одним із наших співробітників безпосередньо в чаті",
  chat_bot: 'Чат-бот',
  live_bot: 'Живий чат',
  maximize: 'Максимізувати',
  minimize: 'Мінімізувати',
  upload_file: 'Помістіть файл для завантаження сюди',
  upload_file_or: 'або',
  Upload_file_select: 'Додати файли',
  upload_file_text: 'Скиньте файл для завантаження',
  show_attachments: 'Показати вкладення',
  hide_attachments: 'Приховати вкладення',
  tooBig: 'Файл занадто великий',
  tooSmall: 'Файл занадто малий',
  invalidFileTypeCopilot:
    'Недійсний тип файлу. Наразі підтримуються лише типи файлів .png, .jpg, .jpeg, .gif.',
  tooManyFiles: 'Будь ласка, завантажуйте максимум 5 файлів одночасно',
  chatProtocol: 'Протокол чату',
  showMore: 'Показати більше',
  showLess: 'Показати менше',
  uploadTooltip: 'Завантажити файл',
  uploadFilesTooltip: 'Завантажити файли',
  pdfDownloadTooltip: 'Завантажити Розмова',
  feedbackDescription: "Зворотній зв'язок до нас",
  feedbackPlaceholder: 'Введіть своє повідомлення тут...',
  feedbackInfoPlaceholder: 'Додайте конкретні деталі...',
  feedbackSubtitle: {
    description:
      'Тут ви можете надсилати нам загальні побажання, пропозиції та запити.',
    note: 'Зверніть увагу, що ми не можемо на них відповісти.',
    hint:
      'Всі інші проблеми, які стосуються саме вашої оренди або пошуку квартири, ви можете описати нам в чаті.'
  },
  sendFeedback: 'Надіслати',
  giveFeedback: "Зворотній зв'язок до нас",
  feedbackSubmittedSuccessfully: 'Ваш відгук було успішно відправлено.',
  character_limit: 'Символів',
  page: 'с.',
  factually_incorrect: 'Не фактично вірно',
  not_following_instructions: 'Не дотримувався інструкцій повністю',
  info_not_in_document: 'Шукана інформація не знайдена в документі',
  inappropriate_or_offensive: 'Невідповідний або образливий',
  irrelevant: "Не пов'язаний",
  not_fitting_topic: 'Не відповідає темі',
  confusing_information: 'Плутана інформація',
  ignored_important_parts_of_document: 'Ігнорування важливих частин документа',
  interpreted_document_wrong: 'Неправильне тлумачення документа',
  answer_to_generic: 'Відповідь занадто загальна',
  sources_incorrect: 'Джерела ненадійні або неправильно цитовані',
  why_not_helpful: 'Чому це не було корисно?',
  thank_you_feedback: 'Дякуємо за ваш відгук!',
  provide_feedback: 'Надати відгук про відповідь',
  not_helpful: 'Не корисно',
  helpful: 'Корисно',
  regenerate_message: 'Регенерувати',
  copy_message: 'Копіювати',
  copied_message: 'Скопійовано!',
  original_answer: 'Оригінальна відповідь',
  regenerated_answer: 'Регенерована відповідь',
  thinking_message: 'Я думаю...',
  file_path: 'Шлях до файлу: ',
  new_messages: 'Нові повідомлення',
  previous_message: 'Попереднє повідомлення',
  next_message: 'Наступне повідомлення',
  clear_input: 'Очистити введення',
  open_feedback: 'Відкрити відгук',
  file_upload: 'Завантаження файлу',
  expand_quickreplies_aria: 'Показати більше кнопок',
  button_tooltip_switch_locale_german: 'Змінити мову на німецьку',
  button_tooltip_switch_locale_french: 'Змінити мову на французьку',
  button_tooltip_switch_locale_dutch: 'Змінити мову на голландську',
  button_tooltip_switch_locale_turkish: 'Змінити мову на турецьку',
  button_tooltip_switch_locale_russian: 'Змінити мову на російську',
  button_tooltip_switch_locale_swedish: 'Змінити мову на шведську',
  button_tooltip_switch_locale_ukranian: 'Змінити мову на українську',
  button_tooltip_switch_locale_spanish: 'Змінити мову на іспанську',
  button_tooltip_switch_locale_polish: 'Змінити мову на польську',
  button_tooltip_switch_locale_arabic: 'Змінити мову на арабську',
  button_tooltip_switch_locale_italian: 'Змінити мову на італійську',
  button_tooltip_switch_locale_english: 'Змінити мову на англійську',
  message_from_you: 'Ви кажете',
  message_from_bot: 'Бот каже',
  message_from_operator: 'Агент каже',
  new_message_from_bot: 'Бот каже',
  empty_message_received: 'Отримано порожнє повідомлення'
}
